import { AntiTheftGuaranteeBadge } from '@ecomm/shared-icons'

/**
 * Anti-Theft Guarantee Banner component
 * @returns JSX.Element
 */
export function AntiTheftGuaranteeBanner() {
  return (
    <figure
      data-testid="AntiTheftGuaranteeBanner"
      className="grid md:flex items-center border border-solid border-neutral-medium-100 rounded-2xl p-4 lg:pr-32 lg:pl-40 md:py-7 m-0"
    >
      <AntiTheftGuaranteeBadge className="h-28 mx-auto mb-4 md:mb-0" />
      <figcaption className="text-center md:text-left md:ml-8 grid content-evenly md:content-center gap-4">
        <h3 className="font-bold md:text-3xl m-0">
          We stand behind our mission to help prevent crime
        </h3>
        <p className="text-xl md:text-2xl m-0">
          That’s why we offer up to a $500 reimbursement toward your insurance
          deductible if a break-in occurs while your system was armed.*
        </p>
      </figcaption>
    </figure>
  )
}
